import type { Image } from '../lib';
import { z } from 'zod';

export type UploadImageResponse = Image;

export const retrieveImageQuerySchema = z.object({
  id: z.string(),
});

export type RetrieveImageQuery = z.infer<typeof retrieveImageQuerySchema>;

export type RetrieveImageResponse = {
  image: Image;
};
